<template>
  <div style="width: 100%;height:300px;">
    <el-amap
      v-if="showMap"
      class="amap-box"
      ref="amap"
      vid="amap-vue"
      :center="center"
      :plugin="plugin"
      :events="events"
      :zoom="zoom"
      >

      <el-amap-marker
        :position="[pointInfo.reportAddressLong, pointInfo.reportAddressLat]"
        :offset="[-40, -36]"
      >
        <!-- <div class="point">
          {{ pointInfo.reportAddress }}
        </div> -->
        <div style="text-align: center;margin-top:8px;">
          <img
            style="width:23px;height:28px;"
            src="@/assets/image/add.png"
            alt=""
          />
        </div>
      </el-amap-marker>
    </el-amap>
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";
// import geoJson from "./maps.json";
Vue.use(VueAMap);

export default {
  name: "AMap",
  props: {
    pointInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {
      showMap: false,
      amap: null,
      map: null,
      mapApiKey: "f6a6784aeb8609f7920f60ba3161ae54", //您申请的key值
      markersArray: [114.039587, 22.699961],
      zoom: 17,
      lnglatInfo: {
        lng: "",
        lat: "",
        addr: ""
      },
      searchOption: {
        city: "全国",
        citylimit: true
      },
      // center: [114.039587, 22.699961],
      center: [116.334529, 39.977991],
      defaultIcon: require("@/assets/image/add.png"),
      plugin: [
        // {
        //   pName: "Scale",
        //   events: {
        //     init(instance) {
        //       // console.log(instance)
        //     }
        //   }
        // },
        // {
        //   pName: "ToolBar",
        //   position: "RT",
        //   events: {
        //     init(instance) {
        //       // console.log(instance)
        //     }
        //   }
        // }
      ],
      events: {},
      // 绘制边界
      polygonConfig: {
        // 城市边界 配置
        strokeColor: "#5D87FB", // 城市边界颜色
        strokeWeight: 2,
        strokeStyle: "dashed", // 线样式
        fillColor: "#5D87FB", // 遮罩背景色
        fillOpacity: 0.1
      },
      polygonConfig2: {
        // 城市边界 配置
        strokeColor: "#47536e", // 城市边界颜色
        strokeWeight: 2,
        strokeStyle: "dashed", // 线样式
        fillColor: "#47536e", // 遮罩背景色
        fillOpacity: 0.1
      },
      polygons: {
        // 城市边界数据
        De: {}
      },
      district: null,
      polygonlist: [],
      centerInfo: {
        中关村街道: [116.334529, 39.977991],
        希格玛社区: [116.334529, 39.977991],
        观城社区: [114.05810434346834, 22.707008936175022],
        鹭湖社区: [114.06566245123545, 22.687329486802913],
        润城社区: [114.04673358187249, 22.694281998254954],
        松轩社区: [114.06958801770084, 22.7069814886474],
        松元厦社区: [114.07200174675053, 22.717367692104947],
        新田社区: [114.08734496913853, 22.701134760660086],
        新源社区: [114.0821931790433, 22.705550694214462],
        澜园路网格: [114.071122, 22.673623],
        樟坑径社区: [114.086249, 22.676765],
        樟溪社区: [114.08411773050972, 22.689118976948677],
        大和工业网格: [114.052307, 22.696514],
        大和网格: [114.0503227962, 22.6941098054],
        东庵网格: [114.0518772038, 22.6861040352],
        二中网格: [114.048735, 22.707172],
        美中网格: [114.0534066881, 22.6917733831],
        田寮网格: [114.051356, 22.7021],
        大航北网格: [114.045933, 22.70424],
        大航南网格: [114.048274, 22.700479],
        广场网格: [114.04545, 22.695148],
        荷叶榕网格: [114.04748775117375, 22.71000072537888],
        澜园网格: [114.047414, 22.683839],
        圳帮真扶网格: [114.047904, 22.689108],
        中航网格: [114.04781466140297, 22.692635911128264]
      }
      // sqList: ["希格玛社区"]
    };
  },
  created() {
    this.showMap = false;
  },
  mounted() {
    if (this.pointInfo.reportAddressLong) {
      this.center = [this.pointInfo.reportAddressLong, this.pointInfo.reportAddressLat]
    }
    this.$nextTick(() => {
      this.showMap = true;
      this.init();
    });
  },
  beforeDestroy() {
    this.showMap = false;
    this.amap = null;
  },
  methods: {
    // 初始化地图
    init() {
      let _self = this;
      VueAMap.initAMapApiLoader({
        key: _self.mapApiKey,
        plugin: [
          "AMap.AutoComplete",
          "AMap.PlaceSearch",
          "AMap.Scale",
          "AMap.OverView",
          "AMap.ToolBar",
          "AMap.MapType",
          "AMap.PolyEditor",
          "AMap.CircleEditor",
          "AMap.Geocoder",
          "AMap.Boundary",
          "AMap.DistrictSearch",
          "AMap.Geolocation",
          // "AMap.GeoJSON",
          "AMap.Heatmap"
        ],
        // 高德 sdk 版本
        v: "1.4.15"
      });
      // setTimeout(async () => {
      //   _self.amap = _self.$refs.amap.$$getInstance();
      //   _self.addHeadMap();
      // }, 1000);
    },
    // 添加边界
    addGeo() {
      // 社区边界示例
      const that = this;
      geoJson.features.forEach(item => {
        if (item.geometry.coordinates && item.geometry.coordinates.length) {
          that.polygonlist.push({
            path: item.geometry.coordinates,
            ...item.properties,
            center: item.geometry.coordinates[0][0],
            position: item.properties.center
          });
        }
      });
      // 街道边界
      // this.polygons.De = guanhu.features[0].geometry.coordinates;
    },

    // 添加热力图
    addHeadMap() {
      const that = this;
      that.addGeo();
      // that.amap.plugin(["AMap.Heatmap"], function () {
      //   //加载热力图插件
      //   let heatmap = new AMap.Heatmap(that.amap, {
      //     radius: 25, //给定半径
      //     opacity: [0, 0.8]
      //     /*,
      //       gradient:{
      //           0.5: 'blue',
      //           0.65: 'rgb(117,211,248)',
      //           0.7: 'rgb(0, 255, 0)',
      //           0.9: '#ffea00',
      //           1.0: 'red'
      //       }
      //        */
      //   });
      //   heatmap.setDataSet({ data: points, max: 100 }); //设置热力图数据集
      //   //具体参数见接口文档 https://lbs.amap.com/api/javascript-api/reference/layer#m_AMap.Heatmap
      // });
    }
  },
  watch: {
    pointInfo: {
      deep: true,
      handler(val) {
        if (val.reportAddressLong) {
          this.center = [val.reportAddressLong, val.reportAddressLat]
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.amap-box {
  width: 100%;
  min-height: 178px;
}
/deep/.amap-logo {
  right: 0 !important;
  left: auto !important;
  display: none !important;
}

/deep/.amap-copyright {
  right: 70px !important;
  left: auto !important;
  opacity: 0 !important;
}

/deep/ .el-dialog__header {
  border-bottom: 0 !important;
}
.point {
  width: 300px;
  padding: 10px 24px;
  background: #fff;
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: #494c4f;
  box-shadow: 0px 2px 4px 0px rgba(22, 54, 79, 0.08);
  border-radius: 33px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/userManagement/map.vue